//Toast.js
import { toast} from 'vue3-toastify';

export const showSuccessToast = (message, autoClose = null) => {
    toast(message, {
        type: 'success',
        autoClose: autoClose ?? 2000,
    });
};

export const showErrorToast = (message, autoClose = null) => {
    toast(message, {
        type: 'error',
        autoClose: autoClose ?? 2000,
    });
};

export const showInfoToast = (message, autoClose = null) => {
    toast(message, {
        type: 'info',
        autoClose: autoClose ?? 2000,
    });
};

export const showWarningToast = (message, autoClose = null) => {
    toast(message, {
        type: 'warning',
        autoClose: autoClose ?? 2000,
    });
};
